import React from "react";
import * as Icon from "react-bootstrap-icons";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// Bootstrap imports
import {
    Button
  } from "react-bootstrap";

/**
   * This is a Template explaainaationm popup component renderer.
   * @param {*} props: Template properties.
   * @returns: Explain Template Popover component.
   */
  export const TemplateDescriptionPopover = (props) => {
    console.log("TEMPLATE DESCRIPTION PROPS: ", props)
    return (
        <OverlayTrigger
        trigger="hover"
        placement="bottom"
        overlay={
          <Popover id="popover-basic">
            <Popover.Header as="h3">Report template description</Popover.Header>
            <Popover.Body>
              {Object.keys(props.description).map((index)=>(
                <>
                <p>For file <b>{index}</b> : </p>
                <p>{props.description[index]}</p>
                </>
    ))}
            </Popover.Body>
          </Popover>
        }
      >
        <Button className="tooltip-pop" style={{marginLeft: 20, marginBottom: -5}}>
          <Icon.PatchQuestionFill />{" "}
        </Button>
      </OverlayTrigger>
    )
  }